<div class="container-fluid userPage py-3">
  <div class="row">

    <!-- -------------------------------------------------------------------- -->
    <!--                             ANCHOR HEADER                            -->
    <!-- -------------------------------------------------------------------- -->
    <div class="col-12 mb-3">

      <!-- Un solo row: el responsive se resuelve con col-lg-*, no abriendo
           filas extra. -->
      <div class="row g-2 align-items-center">

        <div class="col-auto">
          <a
            [routerLink]="['../']"
            class="btn btn-light rounded-circle userPage__iconBtn"
            aria-label="Volver al listado de usuarios"
            title="Volver">
            <i class="material-icons" aria-hidden="true">arrow_back</i>
          </a>
        </div>

        <div class="col placeholder-glow">
          @if (loading) {
            <span
              class="placeholder col-6 rounded d-block userPage__skeletonTitle mb-2"
              aria-hidden="true">
            </span>
            <span
              class="placeholder col-4 rounded d-block userPage__skeletonText"
              aria-hidden="true">
            </span>
          } @else if (user) {
            <h1 class="userPage__title text-truncate mb-1">{{ user.username }}</h1>
            @if (user.personName) {
              <p class="userPage__subtitle text-truncate mb-0">{{ user.personName }}</p>
            } @else {
              <!-- Dato ausente: gris + texto explícito, nunca rojo. -->
              <p class="userPage__subtitleOff text-truncate mb-0">Sin nombre capturado</p>
            }
          } @else {
            <h1 class="userPage__title mb-0">Usuario</h1>
          }
        </div>

        <!-- El enlace con texto acompaña a la flecha: en < lg la flecha sola es
             el único camino de regreso y conviene nombrarlo. -->
        <div class="col-12 col-lg-auto">
          <div class="d-flex align-items-center justify-content-lg-end">
            <a
              [routerLink]="['../']"
              class="btn btn-light userPage__backBtn">
              <i class="material-icons userPage__backIcon" aria-hidden="true">list</i>
              Ver todos los usuarios
            </a>
          </div>
        </div>

      </div>
    </div>

    <!-- -------------------------------------------------------------------- -->
    <!--                           ANCHOR NOT FOUND                           -->
    <!-- -------------------------------------------------------------------- -->
    @if (!loading && notFound) {

      <div class="col-12">
        <div class="userPage__panel">
          <div class="userPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
            <i class="material-icons userPage__emptyIcon" aria-hidden="true">search_off</i>
            <p class="userPage__emptyTitle mb-1">No pudimos cargar este usuario</p>
            <p class="userPage__emptyText mb-3">
              Puede que ya no exista o que el servidor no haya respondido.
              Intenta de nuevo o vuelve al listado.
            </p>
            <div class="d-flex flex-wrap justify-content-center gap-2">
              <button
                (click)="getData()"
                type="button"
                class="btn btn-outline-primary userPage__emptyBtn">
                Reintentar
              </button>
              <a
                [routerLink]="['../']"
                class="btn btn-light userPage__emptyBtn">
                Ver todos los usuarios
              </a>
            </div>
          </div>
        </div>
      </div>

    }

    @if (!notFound) {

      <!-- ------------------------------------------------------------------ -->
      <!--                            ANCHOR FICHA                            -->
      <!-- ------------------------------------------------------------------ -->
      <div class="col-12 mb-3">
        <div class="userPage__panel p-3">

          <h2 class="userPage__sectionTitle mb-3">Datos del usuario</h2>

          @if (loading) {

            <div class="row g-3 placeholder-glow">
              @for (skeletonField of skeletonFields; track $index) {
                <div class="col-12 col-lg-4">
                  <span
                    class="placeholder col-5 rounded d-block userPage__skeletonText mb-2"
                    aria-hidden="true">
                  </span>
                  <span
                    class="placeholder col-8 rounded d-block userPage__skeletonText"
                    aria-hidden="true">
                  </span>
                </div>
              }
            </div>

          } @else if (user) {

            <!-- Pares etiqueta/valor: <dl> es la semántica correcta de una ficha
                 de solo consulta. La rejilla la sigue resolviendo Bootstrap. -->
            <dl class="row g-3 mb-0">

              <div class="col-12 col-lg-4">
                <dt class="userPage__fieldLabel">Usuario</dt>
                <dd class="userPage__fieldValue text-break mb-0">{{ user.username }}</dd>
              </div>

              <div class="col-12 col-lg-4">
                <dt class="userPage__fieldLabel">Nombre</dt>
                @if (user.personName) {
                  <dd class="userPage__fieldValue text-break mb-0">{{ user.personName }}</dd>
                } @else {
                  <dd class="userPage__fieldValueOff mb-0">Sin nombre capturado</dd>
                }
              </div>

              <div class="col-12 col-lg-4">
                <dt class="userPage__fieldLabel">Correo</dt>
                @if (user.hasEmail) {
                  <dd class="userPage__fieldValue text-break mb-0">{{ user.email }}</dd>
                } @else {
                  <dd class="userPage__fieldValueOff mb-0">Sin correo</dd>
                }
              </div>

              <div class="col-12 col-lg-4">
                <dt class="userPage__fieldLabel">Perfil</dt>
                <dd class="mb-0">
                  <!-- El perfil se lee por texto; el color solo acompaña. -->
                  <span
                    class="userPage__badge"
                    [class.userPage__badge--sudo]="user.isSudo">
                    <i class="material-icons userPage__badgeIcon" aria-hidden="true">
                      {{ user.isSudo ? 'shield' : 'person' }}
                    </i>
                    {{ user.profileLabel }}
                  </span>
                </dd>
              </div>

              <div class="col-12 col-lg-4">
                <dt class="userPage__fieldLabel">Último acceso</dt>
                @if (user.hasLoggedIn) {
                  <dd class="userPage__fieldValue mb-0">
                    {{ user.lastLoginAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                  </dd>
                } @else {
                  <!-- Nunca entró NO es un error: gris, nunca rojo. -->
                  <dd class="userPage__fieldValueOff mb-0">Nunca ha iniciado sesión</dd>
                }
              </div>

              <div class="col-12 col-lg-4">
                <dt class="userPage__fieldLabel">Alta</dt>
                <dd class="userPage__fieldValue mb-0">
                  {{ user.createdAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                </dd>
              </div>

            </dl>

          }

        </div>
      </div>

      <!-- ------------------------------------------------------------------ -->
      <!--                         ANCHOR PROPIEDADES                         -->
      <!-- ------------------------------------------------------------------ -->
      <div class="col-12 mb-2">
        <div class="row g-2 align-items-center">

          <div class="col placeholder-glow">
            <h2 class="userPage__sectionTitle mb-0">Propiedades</h2>

            @if (loading) {
              <span
                class="placeholder col-4 rounded d-inline-block userPage__skeletonText"
                aria-hidden="true">
              </span>
            } @else {
              <p class="userPage__sectionHint mb-0">
                @if (hasProperties) {
                  {{ properties.length }}
                  {{ properties.length === 1
                      ? 'propiedad asignada'
                      : 'propiedades asignadas' }}
                } @else {
                  Ninguna propiedad asignada
                }
              </p>
            }
          </div>

        </div>
      </div>

      <div class="col-12">

        @if (loading) {

          <div class="row g-3">
            @for (skeletonProperty of skeletonProperties; track $index) {
              <div class="col-12 col-lg-6">
                <div class="userPage__property placeholder-glow">
                  <span
                    class="placeholder col-7 rounded d-block userPage__skeletonTitle mb-2"
                    aria-hidden="true">
                  </span>
                  <span
                    class="placeholder col-5 rounded d-block userPage__skeletonText mb-2"
                    aria-hidden="true">
                  </span>
                  <span
                    class="placeholder col-6 rounded d-block userPage__skeletonText"
                    aria-hidden="true">
                  </span>
                </div>
              </div>
            }
          </div>

        } @else if (hasProperties) {

          <div class="row g-3">
            @for (property of properties; track property.houseFlatId) {
              <div class="col-12 col-lg-6">
                <div class="userPage__property h-100">

                  <div class="d-flex align-items-start gap-2 mb-2">
                    <i class="material-icons userPage__propertyIcon" aria-hidden="true">home</i>
                    <div class="d-flex flex-column">
                      <span class="userPage__propertyTitle">{{ property.addressLabel }}</span>
                      @if (property.hasNeighborhood) {
                        <span class="userPage__propertyMeta">{{ property.neighborhood }}</span>
                      } @else {
                        <span class="userPage__propertyMetaOff">
                          {{ property.neighborhoodLabel }}
                        </span>
                      }
                    </div>
                  </div>

                  <dl class="row g-2 mb-0">

                    <div class="col-12 col-lg-6">
                      <dt class="userPage__fieldLabel">Número</dt>
                      @if (property.hasNumber) {
                        <dd class="userPage__fieldValue text-break mb-0">{{ property.number }}</dd>
                      } @else {
                        <dd class="userPage__fieldValueOff mb-0">{{ property.numberLabel }}</dd>
                      }
                    </div>

                    <div class="col-12 col-lg-6">
                      <dt class="userPage__fieldLabel">Calle o edificio</dt>
                      @if (property.hasStreetBuilding) {
                        <dd class="userPage__fieldValue text-break mb-0">
                          {{ property.streetBuilding }}
                        </dd>
                      } @else {
                        <dd class="userPage__fieldValueOff mb-0">
                          {{ property.streetBuildingLabel }}
                        </dd>
                      }
                    </div>

                    <div class="col-12 col-lg-6">
                      <dt class="userPage__fieldLabel">Tipo de residente</dt>
                      <dd class="mb-0">
                        @if (property.hasResidentType) {
                          <span class="userPage__badge">
                            <i class="material-icons userPage__badgeIcon" aria-hidden="true">badge</i>
                            {{ property.residentType }}
                          </span>
                        } @else {
                          <!-- Sin capturar: gris + texto, nunca rojo. -->
                          <span class="userPage__fieldValueOff">
                            {{ property.residentTypeLabel }}
                          </span>
                        }
                      </dd>
                    </div>

                    <div class="col-12 col-lg-6">
                      <dt class="userPage__fieldLabel">Asignada el</dt>
                      <dd class="userPage__fieldValue mb-0">
                        {{ property.createdAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                      </dd>
                    </div>

                  </dl>

                </div>
              </div>
            }
          </div>

        } @else {

          <!-- Lista vacía NO es un error: los superadministradores, los
               administradores y los vigilantes no son residentes de ninguna
               propiedad. Se explica en gris, sin rojo y sin botones. -->
          <div class="userPage__panel">
            <div class="userPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
              <i class="material-icons userPage__emptyIcon" aria-hidden="true">home_work</i>
              <p class="userPage__emptyTitle mb-1">Este usuario no pertenece a ninguna propiedad</p>
              <p class="userPage__emptyText mb-0">
                Solo los residentes tienen casa o departamento asignado. Los
                superadministradores, los administradores y los vigilantes
                aparecen aquí sin propiedades, y eso es lo esperado.
              </p>
            </div>
          </div>

        }

      </div>

    }

    <!-- -------------------------------------------------------------------- -->
    <!--                          ANCHOR LIVE REGION                          -->
    <!-- -------------------------------------------------------------------- -->
    <!-- Vive siempre en el DOM: un aria-live que aparece junto con su texto no
         se anuncia. -->
    <div class="col-12 visually-hidden" role="status" aria-live="polite">
      {{ liveMessage }}
    </div>

  </div>
</div>
